import { findChildren, getNodeNesteData } from '../services/entities/simulations';

// const additoinalOptions = [
//     { title: "Context", value: "context" },
//     { title: "Predefined Function", value: "predefined_function" },
// ]


const additoinalOptions = (predefinedFunctions, type) => {

    if( predefinedFunctions !== undefined) {
        const predefinedOptions = predefinedFunctions.map(item => {
            return { title: item.function_label, value: item.function_name }
        })
        return [{ title: "Context", value: "context" }, ...predefinedOptions]
    } else {
        return [{ title: "Context", value: "context" }]
    }
}

export const contextOptions = [
    { title: "String", value: "string" },
    { title: "Number", value: "number" },
    { title: "Boolean", value: "boolean" }
]

const capitalizeFirstLetter = (str) => {
    if (str == undefined) return ""
    return str.charAt(0).toUpperCase() + str.slice(1);
}


export const triggerEventSchema = {
    type: 'object',
    required: ['event'],
    title: "",
    options: {
        layout: 'grid',
        disable_properties: 'false'
    },
    properties: {
        event: {
            title: 'Event Name',
            type: 'string',
            type: 'string',
            readOnly: true,
            format: "grid",
            options: {
                layout: 'grid',
                grid_columns: 12,
            }
        }
    }

}

export const eventDropdownSchema = (candidateEvents, fields, messages) => {

    const schema = [{ name: "Select an event", _id: 'select' }, ...candidateEvents].map((item) => {

        let singleSchema = {
            title: item?.name,
            type: "object",
            default: item._id,
            properties: {
                [item._id]: { default: item._id, type: 'string', options: { hidden: true } },

            },
            additionalProperties: false
        };

        if (item._id != "select") {
            const message = messages.find(ele => ele._id == item.message);
            const nestedData = findChildren(message, [], fields, messages, false);
            const messageFields = nestedData?.children ? nestedData.children : [];
            const payloadSchemaObj = payloadSchema(messageFields);
            if (Object.keys(payloadSchemaObj)?.length > 0) {
                singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...payloadSchemaObj } };

            }
        }
        
        return singleSchema;

    });
    return schema;
}


export const responseEventSchema = (candidateEvents, fields, messages, isOneOf = false) => {
    let eventDropdownSchemaObj = eventDropdownSchema(candidateEvents, fields, messages);
    if(!isOneOf){
        eventDropdownSchemaObj = [eventDropdownSchemaObj[1]]
    }
    
    return {
        type: 'object',
        required: ['event'],
        title: "",
        options: {
            layout: 'grid',
            disable_properties: 'false',
        },
        properties: {
            event: {
                title: 'Event Name',
                type: 'object',
                oneOf: [...eventDropdownSchemaObj],
                options: {
                    layout: 'grid',
                    disable_properties: 'false',
                }
            }
        }
    }
}

export const methodSchema = {
    method: {
        title: 'Method',
        type: 'string',
        readOnly: true,
        format: "grid",
        options: {
            layout: 'grid',
            grid_columns: 6,
        }
    }
}

export const pathSchema = {
    path: {
        title: 'Path',
        type: 'string',
        readOnly: true,
        format: "grid",
        options: {
            layout: 'grid',
            grid_columns: 6,
        }
    }
}




export const argumentsSchema = (predefinedFunctions) => {
    
    let schema = {
        arguments: {
            type: "array",
            title: "Arguments",
            format: "table",
            items: {
                type: "object",
                title: "Arguments",
                properties: {
                    argument: {
                        type: "string",
                        title: "",
                        readOnly: true,
                        options: {
                            layout: 'grid',
                            grid_columns: 3,
                        }
                    },
                    type: {
                        title: 'Type',
                        type: 'string',
                        enumSource: [{
                            // source: [{ title: "Default", value: "default" }],
                            source: [{ title: "Constant", value: "default" }, ...additoinalOptions(predefinedFunctions)],
                            title: '{{item.title}}',
                            value: '{{item.value}}'
                        }],
                        format: "grid",
                        options: {
                            layout: 'grid',
                            grid_columns: 3,
                        }
                    },
                    value: {
                        type: "string",
                        title: "",
                        options: {
                            layout: 'grid',
                            grid_columns: 6,
                        }
                    }
                },
                format: "grid",
                options: {
                    layout: 'grid',
                    disable_properties: 'false',
                }
            }
        }
    }

    return schema
}

export const generateSchemaForNestedStructure = (nestedStructure, predefinedFunctions) => {
    console.log("generateSchemaForNestedStructure------------------------------", {nestedStructure})
    const schema = {};
    const requiredFields = [];
    const optionalFields = [];
    nestedStructure?.forEach(item => {
        if (item.attributes.optional === true) {
            optionalFields.push(item.name);
        } else {
            requiredFields.push(item.name);
        }
        if (item.children?.length > 0 || item.attributes.type == "struct") {
            const nestedSchema = generateSchemaForNestedStructure(item.children, predefinedFunctions);
            if(item.attributes.collection){
                schema[item.name] = {
                    type: "array",
                    title: item.name,
                    items: {
                        type: "object",
                        properties: { ...nestedSchema.schema },
                        required: nestedSchema.requiredFields,
                        defaultProperties: nestedSchema.requiredFields
                    }
                }
            }else{
                schema[item.name] = {
                    type: "object",
                    title: item.name,
                    properties: { ...nestedSchema.schema },
                    required: nestedSchema.requiredFields,
                    defaultProperties: nestedSchema.requiredFields
                }
            }
            
        } else {

            if(item.attributes.collection){
                schema[item.name] = {
                    type: "array",
                    title: item.name,
                    items: {
                        type: "object",
                        // description: item.attributes.desc ? `${item.attributes.desc} _type_ (${item?.attributes?.type})` : "",
                        description: getFieldDetails(item.name, item?.attributes?.type, item.attributes.desc),
                        properties: {
                            field: {
                                type: "string",
                                title: "Field",
                                readOnly: true,
                                format: "grid",
                                options: {
                                    layout: 'grid',
                                    grid_columns: 3,
                                }
                            },
                            type: {
                                title: 'Type',
                                type: 'string',
                                enumSource: [{
                                    // source: [{ title: item?.attributes?.type.toLowerCase(), value: item?.attributes?.type.toLowerCase() }],
                                    source: [{ title: 'Constant', value: item?.attributes?.type.toLowerCase() }, ...additoinalOptions(predefinedFunctions, item?.attributes?.type)],
                                    title: '{{item.title}}',
                                    value: '{{item.value}}'
                                }],
                                format: "grid",
                                options: {
                                    layout: 'grid',
                                    grid_columns: 3,
                                }
                            },
                            value: {
                                type: "string",
                                title: "Value",
                                format: "grid",
                                options: {
                                    layout: 'grid',
                                    grid_columns: 6,
                                }
                            }, 
        
                            field_id: {
                                type: 'string',
                                format: 'hidden'
                            },
                            originalType: {
                                type: 'string',
                                format: 'hidden'
                            }
        
                        },
                        options: {
                            layout: 'grid',
                            disable_properties: 'false',
                        },
                        required: requiredFields?.includes(item.name) ? ['field'] : []
                    }
                }
            }else{
                schema[item.name] = {
                    type: "object",
                    title: item.name,
                    // description: item.attributes.desc ? `${item.attributes.desc} _type_ (${item?.attributes?.type})` : "",
                    description: getFieldDetails(item.name, item?.attributes?.type, item.attributes.desc)  ,
                    properties: {
                        field: {
                            type: "string",
                            title: "Field",
                            readOnly: true,
                            format: "grid",
                            options: {
                                layout: 'grid',
                                grid_columns: 3,
                            }
                        },
                        type: {
                            title: 'Type',
                            type: 'string',
                            enumSource: [{
                                // source: [{ title: item?.attributes?.type.toLowerCase(), value: item?.attributes?.type.toLowerCase() }],
                                source: [{ title: 'Constant', value: item?.attributes?.type.toLowerCase() }, ...additoinalOptions(predefinedFunctions, item?.attributes?.type)],
                                title: '{{item.title}}',
                                value: '{{item.value}}'
                            }],
                            format: "grid",
                            options: {
                                layout: 'grid',
                                grid_columns: 3,
                            }
                        },
                        value: {
                            type: "string",
                            title: "Value",
                            format: "grid",
                            options: {
                                layout: 'grid',
                                grid_columns: 6,
                            }
                        }, 
                        field_id: {
                            type: 'string',
                            format: 'hidden'
                        },
                        originalType: {
                            type: 'string',
                            format: 'hidden'
                        }
    
                    },
                    options: {
                        layout: 'grid',
                        disable_properties: 'false',
                    },
                }
                if (requiredFields.includes(item.name)) {
                    schema[item.name].required = ['field'];
                }
            }
        }
    });
    return { schema, optionalFields, requiredFields };
}

const getFieldDetails = (name, type, desc) => {
    const data = {
        name,
        type,
        desc: desc ? desc : "" 
    }

    return JSON.stringify(data)
}

export const payloadSchema = (messageFields, predefinedFunctions) => {
    

    if (messageFields.length > 0) {
        const { schema, optionalFields, requiredFields } = generateSchemaForNestedStructure(messageFields, predefinedFunctions);

        let payloadSchemaObj = {
            payload: {
                type: "object",
                required: requiredFields,
                title: "Test Data",
                properties: { ...schema },
                defaultProperties: requiredFields,

            },
        };
        return payloadSchemaObj;
    }
    return {};
}


export const generateSchemaForNestedProfile = (nestedStructure, isUserTrigger) => {

    const schema = {};
    const requiredFields = [];
    const optionalFields = [];

    console.log({nestedStructure});
    nestedStructure?.forEach(item => {
        if (item?.attributes?.optional === true) {
            optionalFields.push(item.name);
        } else {
            requiredFields.push(item.name);
        }
        if (item.children?.length > 0 || item?.attributes?.type == "struct") {
            const nestedSchema = generateSchemaForNestedProfile(item.children, isUserTrigger);
            // console.log('nestedScema-------->', nestedSchema)
            if(item.attributes?.type == "table"){
                schema[item.name] = {
                    type: "array",
                    title: item.name,
                    items: {
                        type: "object",
                        properties: { nodeId: { default: item._id, type: 'string', options: { hidden: true, layout: 'grid', grid_columns: 6, } }, ...nestedSchema.schema, },
                        required: nestedSchema.requiredFields,
                        defaultProperties: nestedSchema.requiredFields
                    },
                }
            }else{
                schema[item.name] = {
                    type: "object",
                    title: item.name,
                    properties: { nodeId: { default: item._id, type: 'string', options: { hidden: true, layout: 'grid', grid_columns: 6, } }, ...nestedSchema.schema, },
                    required: nestedSchema.requiredFields,
                    defaultProperties: nestedSchema.requiredFields
                }
            }
        } else {
            console.log(item,'this is item');
            schema[item.name] = {
                type: item.attributes?.type === 'table' ? "array" : "object",
                title: item.name,
                options: {
                    layout: 'grid',
                    disable_properties: 'false',
                },
            }
            if(item.attributes?.type === 'table'){
                schema[item.name].items = {
                    type: "object",
                    options: {
                        layout: 'grid',
                        disable_properties: 'false',
                    },
                    properties: !item.attributes?.type ? {} : {
                        field: {
                            type: "string",
                            title: "Field",
                            readOnly: true,
                            format: "grid",
                            options: {
                                layout: 'grid',
                                grid_columns: 3,
                            }
                        },
                        type: {
                            title: 'Type',
                            type: 'string',
                            readOnly: true,
                            format: "grid",
                            default: item?.attributes?.type ? item.attributes.type.toLowerCase() : "",
                            options: {
                                layout: 'grid',
                                grid_columns: 3,
                            }
                        },
                        value: {
                            type: "string",
                            title: "Value",
                            format: "grid",
                            options: {
                                layout: 'grid',
                                grid_columns: 6,
                            }
                        },
                        nodeId: {
                            default: item._id,
                            type: 'string',
                            options: {
                                hidden: true, layout: 'grid', grid_columns: 6,
                            }
                        }
                    }
                }
            }else{
                schema[item.name].properties = !item.attributes?.type ? {} : {
                    field: {
                        type: "string",
                        title: "Field",
                        readOnly: true,
                        format: "grid",
                        options: {
                            layout: 'grid',
                            grid_columns: 3,
                        }
                    },
                    type: {
                        title: 'Type',
                        type: 'string',
                        // enumSource: [{
                        //     // source: [{ title: item?.attributes?.type.toLowerCase(), value: item?.attributes?.type.toLowerCase() }],
                        //     source: [{ title: capitalizeFirstLetter(item?.attributes?.type?.toLowerCase()) ? capitalizeFirstLetter(item?.attributes?.type?.toLowerCase()) : "", value: item?.attributes?.type?.toLowerCase() ? item?.attributes?.type?.toLowerCase() : "" }],
                        //     title: '{{item.title}}',
                        //     value: '{{item.value}}'
                        // }],
                        readOnly: true,
                        format: "grid",
                        default: item?.attributes?.type ? item.attributes.type.toLowerCase() : "",
                        options: {
                            layout: 'grid',
                            grid_columns: 3,
                        }
                    },
                    value: {
                        type: "string",
                        title: "Value",
                        format: "grid",
                        options: {
                            layout: 'grid',
                            grid_columns: 6,
                        }
                    },
                    nodeId: {
                        default: item._id,
                        type: 'string',
                        options: {
                            hidden: true, layout: 'grid', grid_columns: 6,
                        }
                    }
                }
            }
            if (requiredFields.includes(item.name) && item.type !== 11) {
                schema[item.name].required = ['field'];
            }
            if (!isUserTrigger) {
                schema[item.name].description = item?.attributes?.desc ? item?.attributes?.desc : "";
            }
        }
    });
    return { schema, optionalFields, requiredFields };
}


export const profileNestedSchema = (profileChildren) => {

    console.log('profileChildren--------->', profileChildren)


    if (profileChildren.length > 0) {
        const { schema, optionalFields, requiredFields } = generateSchemaForNestedProfile(profileChildren);

        console.log('profileops------>', { requiredFields, profileChildren })


        let payloadSchemaObj = {
            profile: {
                type: "object",
                required: requiredFields,
                title: "Profile",
                properties: { ...schema },
                defaultProperties: requiredFields,
                options: {
                    layout: 'grid',
                    grid_columns: 12,
                }
            },
        };
        return payloadSchemaObj;
    }
    return {};
}

export const profileDropdownSchema = (profiles, sections, fields) => {

    const schema = [{ name: "Select a profile", _id: 'select' }, ...profiles].map((item) => {
        let singleSchema = {
            title: item.name,
            type: "object",
            default: item._id,
            properties: {
                [item._id]: { default: item._id, type: 'string', options: { hidden: true, layout: 'grid', grid_columns: 6, } },
                description: {
                    type: "string",
                    format: 'textarea',
                    title: "Description",
                    default: "",
                    options: {
                        layout: 'grid',
                        grid_columns: 12,
                    }
                },
                instance: {
                    type: "string",
                    title: "Instance",
                    format: "grid",
                    default: "default",
                    options: {
                        layout: 'grid',
                        grid_columns: 12,
                    }
                }

            },
            additionalProperties: false
        };
        const profileFields = getNodeNesteData(item, sections, fields);
        const payloadSchemaObj = profileNestedSchema(profileFields);
        console.log({payloadSchemaObj});
        if (Object.keys(payloadSchemaObj)?.length > 0) {
            singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...payloadSchemaObj } };

        }
        return singleSchema;

    });
    return schema;
}



export const profileSchema = (profiles, sections, fields) => {
    
    const profileDropdownSchemaObj = profileDropdownSchema(profiles, sections, fields);

    return {
        type: 'object',
        required: ['profile'],
        title: "",
        options: {
            layout: 'grid',
            disable_properties: 'false',
        },
        properties: {
            profile: {
                title: 'Profile',
                type: 'object',
                oneOf: [...profileDropdownSchemaObj],
                options: {
                    layout: 'grid',
                    grid_columns: 6,
                    disable_properties: 'false',
                }
            },


        }

    }
}


export const formatProfilePayload = (obj, fields, sections, profileId) => {
    let result = [];

    let allSections = JSON.parse(JSON.stringify(sections));
    let profileSections = sections.filter(sec => sec.parent[0].id == profileId)

    console.log('formted obje ---->', { profileSections, obj })

    function traverse(currentObj, parentKeys, parent = '') {
        for (let key in currentObj) {
            if (currentObj.hasOwnProperty(key)) {
                const newPath = parentKeys.concat(key);
                const nestedObj = currentObj[key];



                if (nestedObj && typeof nestedObj === 'object') {
                    traverse(nestedObj, newPath, key);
                } else if (key === 'field' && currentObj.hasOwnProperty('type') && currentObj.hasOwnProperty('value')) {

                    let field_id = fields.find(fd => fd._id == currentObj.nodeId)._id.toString()

                    result.push({
                        field: field_id ? field_id : newPath[newPath.length - 2], // Get the second-to-last element in the path array
                        type: currentObj.type,
                        value: currentObj.value
                    });
                }
            }
        }
    }

    traverse(obj, []);

    return result;
}

export const getUserTriggerSchema = (messageFields) => {

    if (messageFields.length > 0) {
        const { schema, optionalFields, requiredFields } = generateSchemaForNestedProfile(messageFields, true);

        console.log('schema-------->', schema)

        let payloadSchemaObj = {
            payload: {
                type: "object",
                required: requiredFields,
                title: "Message",
                properties: { ...schema },
                defaultProperties: optionalFields,

            },
        };
        return payloadSchemaObj;
    }
    return {};

}








